import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  //tab
  tabsWrapper: {
    marginLeft: "16px",
    "& .MuiTabs-root": {
      height: "65px",
      "& .MuiTabs-scroller": {
        "& .MuiTabs-indicator": {
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
  },
  tab: {
    textTransform: "none",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "14px",
    marginRight: "16px",
    padding: "0 !important",

    "& .MuiTab-iconWrapper": {
      marginRight: "3px",
      position: "relative",
      top: "-1px"
    },
  },
}));

export default useStyles;
